// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2w7lP","Open":"SideDrawer_Open__1ajMJ","Close":"SideDrawer_Close__2O0DL","Logo":"SideDrawer_Logo__1ZxqZ"};